<template>
  <div class='legend-widget-cell'>
    <div class='legend-section'>
      <div class="material-icons" :style="{'color': color}">
        fiber_manual_record
      </div>
      <div class='label'>
        {{ label }}
      </div>
    </div>
    <div class='value-section'>
      {{ value }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'LegendWidgetCell',
  props: {
    value: {
      required: true,
      type: Number,
    },
    color: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';
.legend-widget-cell {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: rem(10);
  margin-top: rem(10);
  margin-right: rem(10);
  .legend-section {
    display: flex;
    align-items: center;
    .label {
      display: flex;
      margin-left: rem(5);
      color: var(--text-secondary);
      text-transform: uppercase;
      font-family: $font-family-regular;
      font-size: rem(10);
      letter-spacing: rem(1.1);
      line-height: rem(15);
    }
  }
  .value-section {
    display: flex;
    margin-left: rem(20);
    align-self: center;
    font-family: $font-family-semibold;
    font-size: rem(18);
    font-weight: 600;
    letter-spacing: 0;
    line-height: rem(20);
    color: var(--text-primary);
  }
}
</style>
